import get from "lodash/get";
import { mapPrice, mapReducedPrice } from "./price";
import { mapBadgeType } from "./mapBadge";

export const mapProducts = products =>
  products.map(product => {
    const price = mapPrice(product.price);

    return {
      id: product.id,
      url: product.url,
      price: price.value,
      description: product.name,
      image: get(product, "imageUrl"),
      badgeType: mapBadgeType(product),
      productType: product.productType,
      colourWayId: get(product, "colourWayId"),
      isSale: get(product, "price.isMarkedDown"),
      reducedPrice: mapReducedPrice(product.price),
      hasMultiplePrices: product.hasMultiplePrices,
      isOutlet: get(product, "price.isOutletPrice")
    };
  });
